import { TFunction } from 'react-i18next';

import { getMappedTranslation } from 'utility/Translate/mappedTranslation';

import { RoomType } from 'proto/Offer/Room/RoomType';

const roomTypeTranslationKeyMap: Partial<Record<RoomType, string>> = {
    [RoomType.SingleBedRoom]: 'TRANS-room-type-single',
    [RoomType.DoubleBedRoom]: 'TRANS-room-type-double',
    [RoomType.FamilyRoom]: 'TRANS-room-type-family',
    [RoomType.TripleBedRoom]: 'TRANS-room-type-triple',
    [RoomType.MultiShareRoom]: 'TRANS-room-type-multi-share',
    [RoomType.Studio]: 'TRANS-room-type-studio',
    [RoomType.Apartment]: 'TRANS-room-type-apartment',
    [RoomType.DuplexBedRoom]: 'TRANS-room-type-duplex-bed-room',
    [RoomType.Bungalow]: 'TRANS-room-type-bungalow',
    [RoomType.Suite]: 'TRANS-room-type-suite',
    [RoomType.Villa]: 'TRANS-room-type-villa',
};

const roomTypeTooltipTranslationKeyMap: Partial<Record<RoomType, string>> = {
    [RoomType.SingleBedRoom]: 'TRANS-room-type-tooltip-single',
    [RoomType.DoubleBedRoom]: 'TRANS-room-type-tooltip-double',
    [RoomType.FamilyRoom]: 'TRANS-room-type-tooltip-family',
    [RoomType.TripleBedRoom]: 'TRANS-room-type-tooltip-triple',
    [RoomType.MultiShareRoom]: 'TRANS-room-type-tooltip-multi-share',
    [RoomType.Studio]: 'TRANS-room-type-tooltip-studio',
    [RoomType.Apartment]: 'TRANS-room-type-tooltip-apartment',
    [RoomType.DuplexBedRoom]: 'TRANS-room-type-tooltip-duplex',
    [RoomType.Bungalow]: 'TRANS-room-type-tooltip-bungalow',
    [RoomType.Suite]: 'TRANS-room-type-tooltip-suite',
    [RoomType.Villa]: 'TRANS-room-type-tooltip-villa',
};

export const buildRoomTypeLabel = (type: RoomType | undefined, t: TFunction) =>
    getMappedTranslation(roomTypeTranslationKeyMap, type, t);

export const buildRoomTypeTooltip = (
    roomType: RoomType | undefined,
    t: TFunction,
    roomClass = '',
    annexBuilding = '',
    roomDescription = ''
) =>
    getMappedTranslation(
        roomTypeTooltipTranslationKeyMap,
        roomType,
        t,
        'TRANS-room-type-tooltip-program',
        {
            roomClass,
            annexBuilding,
            roomDescription,
        }
    );
